module.exports = __webpack_public_path__ + "static/services_pool-de3d9759e72297bc9e72c95ced72756f.jpg";